import script from "./PhoneStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneStep.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneStep.vue?vue&type=style&index=0&id=f3d89672&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3d89672"]])

export default __exports__